'use client';

import React from 'react';
import { Text, InlineStack, Divider } from '@shopify/polaris';
import { useBillingContext } from '@/features/billing/components/BillingContext';

const CreditsInfo: React.FC = () => {
  const { remainingCredits } = useBillingContext();

  return (
    <InlineStack align="center" gap="200">
      <Text as="span" variant="bodyMd" fontWeight="semibold" tone="subdued">
        Credits
      </Text>
      <Divider />
      <Text as="span" variant="bodyMd" fontWeight="semibold" tone="subdued">
        {remainingCredits}
      </Text>
    </InlineStack>
  );
};

export default CreditsInfo;
